export const HERE_MAPS_KEYS = {
  main: 'here-maps',
  ground: 'ground',
  reverseGeocode: 'reverse-geocode',
  geocode: 'geocode',
};

export const hereMapsQueryKeys = {
  getGround: (...args: unknown[]) => [HERE_MAPS_KEYS.main, HERE_MAPS_KEYS.ground, ...args] as const,
  getAddressByGeocode: (...args: unknown[]) => [HERE_MAPS_KEYS.main, HERE_MAPS_KEYS.reverseGeocode, ...args] as const,
  getGeocode: (country: string, state?: string) =>
    [HERE_MAPS_KEYS.main, HERE_MAPS_KEYS.geocode, country, state] as const,
};
